import React, { useState, useEffect } from "react";
import { FaBullseye, FaLock, FaBolt, FaLightbulb } from "react-icons/fa";

const WhoWeAre = () => {
  const [isVisible, setIsVisible] = useState(false);

  const highlights = [
    {
      icon: <FaBullseye />,
      title: "Seeker-Centric",
      description: "We put our users first by making every service experience simple and convenient",
    },
    {
      icon: <FaLock />,
      title: "Trust & Safety",
      description: "We connect users with trusted and verified service professionals",
    },
    {
      icon: <FaBolt />,
      title: "Quick & Reliable",
      description: "Get connected with the right professional quickly and get your job done reliably",
    },
    {
      icon: <FaLightbulb />,
      title: "Smart Solutions",
      description: "Using technology to make finding and hiring service professionals easier",
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="who-we-are-section">
      <div className="who-we-are-container">
        {/* Section Header */}
        <div className={`who-we-are-header ${isVisible ? "who-fade-in" : ""}`}>
          <div className="who-section-badge">
            <span className="who-badge-icon">👥</span>
            <span className="who-badge-text">WHO WE ARE</span>
          </div>

          <h2 className="who-section-title">
            Connecting People with Trusted Professionals
          </h2>

          <p className="who-section-subtitle">
            Making it easier to find, connect, and get services from trusted professionals
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="who-content-grid">
          {/* Left Side - Image & Badge */}
          <div className={`who-image-section ${isVisible ? "who-slide-left" : ""}`}>
            <div className="who-image-wrapper">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=900&fit=crop"
                alt="Picks4Tips Team"
                className="who-main-image"
              />
            </div>
          </div>

          {/* Right Side - Content */}
          <div className={`who-text-section ${isVisible ? "who-slide-right" : ""}`}>
            <div className="who-text-content">
              <p className="who-description">
                <strong>Picks4Tips</strong> is a service platform designed to connect people who need services
                with skilled and trusted professionals. Whether you need help with a home service or want to offer
                your skills, Picks4Tips makes the process simple, convenient, and reliable.
              </p>

              <p className="who-description">
                Our platform brings seekers and responders together in one place, making it easier to post jobs,
                discover suitable professionals, and connect with the right person for the task. With a focus on
                trust, quality, and convenience, Picks4Tips aims to make finding and providing services a seamless experience.
              </p>

              <div className="who-highlights-grid">
                {highlights.map((item, index) => (
                  <div key={index} className="who-highlight-item">
                    <div className="who-highlight-icon">{item.icon}</div>
                    <div className="who-highlight-content">
                      <h4 className="who-highlight-title">{item.title}</h4>
                      <p className="who-highlight-text">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;